<style scoped lang="scss" type="text/scss">
    .info-panel {
        margin-bottom: 1rem;
    }
</style>

<template>
    <el-dialog title="正在添加参赛成员"
               :visible.sync="visibleSync"
               :close-on-click-modal="false"
               @closed="reset"
               width="70%">
        <info-panel class="info-panel">该操作会创建新用户。如目标人员已在本站注册，请使用「添加成员」功能</info-panel>
        <el-form ref="form" :model="memberInfo" :rules="rules" label-width="100px">
            <el-form-item label="参赛队名称" prop="player_id">
                <registrable-manged-player-selector disabled></registrable-manged-player-selector>
            </el-form-item>
            <el-form-item label="姓名" prop="personal_name">
                <el-input v-model="memberInfo.personal_name" placeholder="请输入成员真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="personal_gender">
                <gender-selector v-model="memberInfo.personal_gender"></gender-selector>
            </el-form-item>
            <el-form-item label="角色类型" prop="personal_role">
                <role-selector v-model="memberInfo.personal_role" :fan-disabled="true"></role-selector>
            </el-form-item>

            <el-form-item style="margin-bottom: 0;">
                <el-button type="primary" plain @click="create()" :loading="requesting">确认</el-button>
                <el-button @click="cancel()">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    import InfoPanel from '../../../../components/info-panel/index';
    import UserSearchBox from '../../../sub-components/user-search-box/index';
    import RoleSelector from '../../../sub-components/role-selector/index';
    import GenderSelector from '../../../sub-components/genders-selector/index';
    import RegistrableMangedPlayerSelector from '../../../sub-components/registrable-managed-player-selector';
    import {mapState} from 'vuex';

    export default {
        name: '',
        components: {
            InfoPanel,
            UserSearchBox,
            RoleSelector,
            GenderSelector,
            RegistrableMangedPlayerSelector
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            visible (visible) {
                this.visibleSync = visible;
            },
            visibleSync (visibleSync) {
                this.$emit('update:visible', visibleSync);
            },
            currentManagedPlayerId: {
                immediate: true,
                handler (currentManagedPlayerId) {
                    this.memberInfo.player_id = currentManagedPlayerId;
                }
            }
        },
        data () {
            return {
                requesting: false,
                visibleSync: null,
                memberInfo: {
                    player_id: null
                },
                rules: {
                    player_id: [
                        {required: true, message: '参赛队不能为空', trigger: 'blur'}
                    ],
                    personal_name: [
                        {required: true, message: '成员姓名不能为空', trigger: 'blur'},
                        {min: 1, max: 30, message: '长度不能超过 30 个字', trigger: 'blur'}
                    ],
                    personal_role: [
                        {required: true, message: '请选择成员角色类型', trigger: 'blur'}
                    ],
                    personal_gender: [
                        {required: true, message: '请选择成员性别', trigger: 'blur'}
                    ]
                }
            };
        },
        computed: {
            ...mapState('player', {
                currentManagedPlayerId: state => state.currentManagedPlayerId
            })
        },
        methods: {
            create () {
                this.$refs.form.validate((valid) => {
                    if (!valid) return false;
                    const memberInfo = this.memberInfo;
                    this.$normalRequest('player/addMemberByCreate', memberInfo, '成员添加成功', true, this, 'requesting').then(_ => {
                        this.afterSuccess();
                    }).catch(_ => {
                    });
                });
            },
            cancel () {
                this.visibleSync = false;
            },
            afterSuccess () {
                this.$emit('need-reload');
                this.reset();
            },
            reset () {
                this.$refs.form.clearValidate();
                this.$refs.form.resetFields();
                this.cancel();
            }
        }
    };
</script>
